"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var N3 = _interopRequireWildcard(require("n3"));

var _nodeFetch = _interopRequireDefault(require("node-fetch"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var SparqlEndpoint = /*#__PURE__*/function () {
  function SparqlEndpoint(uri) {
    var logQueries = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    _classCallCheck(this, SparqlEndpoint);

    this._uri = uri;
    this._logQueries = logQueries;
  }

  _createClass(SparqlEndpoint, [{
    key: "getSparqlResultSet",
    value: function getSparqlResultSet(query) {
      var fetchOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (this._logQueries) console.log(query);
      var encodedQuery = encodeURIComponent(query);
      return (0, _nodeFetch["default"])(this._uri + "?query=" + encodedQuery, _objectSpread(_objectSpread({}, fetchOptions), {}, {
        headers: {
          accept: "application/sparql-results+json"
        }
      })).then(function (response) {
        if (!response.ok) {
          throw response.status;
        } else {
          return response.json();
        }
      });
    }
  }, {
    key: "getSparqlRDF",
    value: function getSparqlRDF(query) {
      var fetchOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var parser = new N3.Parser();
      if (this._logQueries) console.log(query);
      var encodedQuery = encodeURIComponent(query);
      return (0, _nodeFetch["default"])(this._uri + "?query=" + encodedQuery, _objectSpread(_objectSpread({}, fetchOptions), {}, {
        headers: {
          accept: "text/turtle"
        }
      })).then(function (response) {
        if (!response.ok) {
          throw response.status;
        } else {
          return response.text();
        }
      }).then(function (text) {
        return parser.parse(text);
      });
    }
  }]);

  return SparqlEndpoint;
}();

exports["default"] = SparqlEndpoint;
module.exports = exports.default;
//# sourceMappingURL=SparqlEndpoint.js.map